import React from 'react'
import useMetaTags from '../../hooks/useMetaTags'
import { AssistanceSection, BoostSection, CustomSection, FAQ, servicesSection } from '../../Data/All_Services_Data/digitalMarketingData';
import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const DigitalMarketing = () => {
    useMetaTags({
      title: "Affordable Digital Marketing Services for Business Growth",
      description:
        "Increase visibility, leads, and ROI with Warrgyizmorsch—your reliable, budget digital marketing Services for SEO, PPC, content, and more",
      keywords:
        "digital marketing services, digital marketing, digital marketing agency, affordable digital marketing services, online marketing, digital marketing company, marketing strategy, digital advertising, digital marketing strategy, ecommerce marketing agencies, ppc marketing agencies",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Best Affordable Digital Marketing Services
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/digital_header_img.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <p>
                  At Warrgyizmorsch, we offer top quality digital marketing
                  services. We get you measurable results,
                  visibility and growth—without the big cost. We believe
                  affordability should never compromise on quality and
                  performance.
                </p>
              </div>

              {/* services help business grow  */}
              <Services_we_offer data={servicesSection} />

              {/* why WM is the best choice  */}
              <Custom_section data={CustomSection} />

              {/* why choose us */}
              <Boost_section data={BoostSection} />

              {/* why work with us  */}
              <Assistance_section data={AssistanceSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
}

export default DigitalMarketing